import React from 'react'
import { Ordering } from 'storfox-filter'

import { RECEIVE_COLUMNS as tableColumns } from './ReceiveTable'

import { FILTER_NAME as name } from '../../constants'

export const receiveOrderingOptions = {
  name,
  tableColumns
}

function ReceiveOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default ReceiveOrderingForm
